import * as actions from './consts';
import getAxios from 'services/axios';
import jwtService from "services/jwt";
import { setUsers } from "store/entities/users/actions";
import { identifyUser, unsetUserId, logEvent } from "services/analytics.js";

const axios = getAxios('id')

const analyticsSetUser = (user) => {
  identifyUser(user.id, {email: user.email});
}

export const signIn = (params) => (dispatch) => {
  jwtService.removeToken();

  dispatch({type: actions.LOGIN_REQUEST});

  return axios.post('/auth/sign-in/', params)
    .then( user => {
      dispatch(setUsers(user));
      dispatch({
        type: actions.LOGIN_SUCCESS,
        id: user.id,
      })
      analyticsSetUser(user);
      logEvent('UserLoggedIn', {}, true)

      return user;
    })
    .catch( error => {
      dispatch({type: actions.LOGIN_FAILURE})

      throw error;
    });
};

export const signUp = (params) => (dispatch) => {
  jwtService.removeToken();

  return axios.post('/auth/sign-up/', params)
    .then( user => {
      dispatch(setUsers(user));
      dispatch({
        type: actions.SIGNUP_SUCCESS,
        id: user.id,
      });
      analyticsSetUser(user);

      return user;
    });
};

export const logout = () => (dispatch) => {
  return axios.post('/auth/revoke')
    .then( response => {
      jwtService.removeToken();
      dispatch({type: actions.LOGOUT_SUCCESS})
      unsetUserId();
      logEvent('UserLoggedOut', {}, true)

      return response;
    })
};

export const getUser = () => (dispatch) => {
  return axios.get('/account')
    .then( user => {
      dispatch(setUsers(user));
      dispatch({
        type: actions.LOGIN_SUCCESS,
        id: user.id,
      });
      analyticsSetUser(user);

      return user;
    })
    .catch( err => {
      dispatch({type: actions.LOGIN_FAILURE});
      throw err;
    })
}

export const resetPasswordRequest = (email) => (dispatch) => {
  return axios.post('/password/email', {email})
    .then( res => {

      return res;
    });
}

export const resetPassword = ({email, password, token}) => (dispatch) => {
  return axios.post('/password/reset', {
    email,
    password,
    password_confirmation: password,
    reset_token: token,
  })
    .then( res => {
      return dispatch(getUser());
    });
}

export const sendInvCode = (inv) => (dispatch, getState) => {
  return axios.put('/invitation-tokens/close', {inv})
    .then( res => {
      console.log('sendInvCode res', res);
      dispatch({
        type: actions.SET_ACCOUNT_STATUS,
        status: res.status,
        userId: getState().auth.id,
      })
    })
}
